<template>
  <div class="pubTopManage">   
  </div>
</template>

<script>
  import { prepare} from '@/api/pages'
  import Cookies from 'js-cookie'
  export default {
      data() {
          return {
            preparename:"",
          }
      },
     
      created() {
         
      },
      mounted() {
          this.getprepare()
      },
      methods: {
       async getprepare(){
                let data = {}
                let res = await prepare(data)
                if(res.code == '200'){
                  Cookies.set('logintype',res.data)
                  if(res.data ==0){
                    this.$router.push({ name: "HomePage" });
                  }else{
                    this.$router.push({ name: "Xindex" });
                  }
                }
        }
      }
  }
</script>

<style lang="scss" scoped>
  .pubTopManage {
      background-color: #f9f9f9;
  }
</style>


// WEBPACK FOOTER //
// src/views/Preparationpage/Preparationpage.vue